import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import thunkMiddleware from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { reducer as authReducer, authMiddleware } from 'src/auth';
import { reducer as userReducer } from 'src/user';
import {
  reducer as accountReducer,
  setTransformVendor as accountSetTransformVendor,
  reducer as taskReducer,
  reducer as sarReducer,
} from 'src/account';
import { reducer as uiReducer } from 'src/ui';
import { reducer as vendorReducer, transformVendor } from 'src/vendor';
import { reducer as transactionReducer } from 'src/transaction';
import {
  reducer as fiReducer,
  reducer as fiSettingsReducer,
} from 'src/financial-institution';
import { reducer as messagingReducer } from 'src/messaging';
import { reducer as paymentReducer } from 'src/payment';
import { reducer as backgroundAssessmentReducer } from 'src/compliance';
import { reducer as metrcReducer } from 'src/metrc';
import { reducer as insuranceReducer } from 'src/insurance';
import { reducer as licenseReducer } from 'src/license';
import { auditsReducer } from 'src/audits';
// dependency injection
accountSetTransformVendor(transformVendor);

const reducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  account: accountReducer,
  ui: uiReducer,
  vendor: vendorReducer,
  transaction: transactionReducer,
  financialInstitution: fiReducer,
  messaging: messagingReducer,
  payment: paymentReducer,
  backgroundAssessment: backgroundAssessmentReducer,
  metrcReceipts: metrcReducer,
  task: taskReducer,
  sar: sarReducer,
  settings: fiSettingsReducer,
  insurance: insuranceReducer,
  licenses: licenseReducer,
  audits: auditsReducer,
});

const middlewares = [];

middlewares.push(thunkMiddleware);
middlewares.push(authMiddleware);
middlewares.push(apiMiddleware);

/**
 * Handles Redux Devtools
 */
function getCompose() {
  const IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
  if (IS_BROWSER && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  }
  return compose;
}

// persist auth and user data
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

const persistedReducer = persistReducer(persistConfig, reducer);

const composeEnhancers = getCompose();

export const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(...middlewares))
);

export const persistor = persistStore(store);
